<template>
  <div class="w-full flex items-center justify-center min-h-screen px-4">
    <div
      class="bg-mocha-mousse-50/70 backdrop-blur-md rounded-2xl shadow-2xl border border-mocha-mousse-200/50 p-8 w-full max-w-md"
    >
      <!-- Header -->
      <div class="text-center mb-8">
        <h1 class="text-2xl font-bold text-mocha-mousse-900 mb-2">
          Login to Enodo
        </h1>
        <p class="text-sm text-mocha-mousse-600">
          You will be redirected to VUO to log in
        </p>
      </div>

      <!-- Login Button -->
      <button
        type="button"
        @click="handleLogin"
        :disabled="isLoading"
        class="w-full py-3 px-4 bg-gradient-to-r from-spicy-mustard-400 to-mocha-mousse-400 text-white font-semibold rounded-xl shadow-sm hover:from-spicy-mustard-500 hover:to-mocha-mousse-500 hover:shadow-lg focus:outline-none focus:ring-4 focus:ring-spicy-mustard-100 transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
      >
        <Icon
          v-if="isLoading"
          icon="mdi:loading"
          class="w-5 h-5 animate-spin"
        />
        <Icon v-else icon="mdi:login" class="w-5 h-5" />
        <span>{{ isLoading ? "Checking session..." : "Login with VUO" }}</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { Icon } from "@iconify/vue";
import authService from "@/services/authService";

const router = useRouter();
const route = useRoute();

const isLoading = ref(true);

const redirectPath = computed(() => route.query.redirect || "/");

onMounted(async () => {
  // If already authenticated (using local state), redirect
  // If session is actually expired on server, the interceptor will handle it
  // Otherwise try to log in from the VUO session cookie, if the browser has one
  const authenticated =
    !!authService.currentUser.value || !!(await authService.getUserFromVuo());
  if (authenticated) {
    router.push(redirectPath.value);
    return;
  }
  isLoading.value = false;
});

function handleLogin() {
  // VUO sends the browser back to the requested page after login
  authService.redirectToVuoLogin(router.resolve(redirectPath.value).href);
}
</script>
